import type { Strings } from '../index.ts';
import { unreadable } from './shared.ts';

/**
 * Die Verlaufsseite.
 *
 * Übrig ist nur noch `malformed`. Zeilen, die nicht gelesen werden konnten, zeichnet die Seite gar
 * nicht, also sagt sonst nichts auf dem Bildschirm, dass sie fehlen. Die Zahl der gelöschten Videos ist
 * dagegen weg (2026-08-07): jede dieser Zeilen trägt `unavailableMarker` schon an ihrem Platz.
 */
export const history: Strings['history'] = {
  notice: {
    malformed: 'Dein Verlauf konnte nicht gelesen werden, deshalb gibt es daraus nichts zu zeigen.',
  },

  unavailableMarker: {
    label: 'Nicht verfügbar',
    title:
      'Dieses Video existiert nicht mehr. Es steht noch in deinem Verlauf, weil kein Eintrag von selbst verschwindet.',
  },

  malformedList: {
    title: 'Dein Verlauf konnte nicht gelesen werden',
    detail: 'Die Instanz hat mit etwas geantwortet, das Visious nicht lesen kann.',
    retryable: true,
  },

  empty: {
    title: 'Noch nichts gesehen',
    detail:
      'Videos erscheinen hier, sobald du etwa eine halbe Minute davon gesehen hast, oder ein Viertel eines kurzen. Aufgezeichnet wird das in deinem Konto auf der Instanz, es folgt dir also zwischen Browsern.',
  },

  problem: {
    notFound: {
      title: 'Diese Instanz führt keinen Wiedergabeverlauf',
      detail: 'Er wird hier nicht angeboten. Manche Instanzen lassen Teile der App weg.',
      retryable: false,
    },
    unreadable: unreadable('Dein Verlauf konnte nicht gelesen werden'),
    disabled: {
      title: 'Der Wiedergabeverlauf ist auf dieser Instanz abgeschaltet',
      detail:
        'Die Administration hat ihn abgeschaltet, es gibt also nichts zu zeigen. Aufgezeichnet wird auch nichts.',
      retryable: false,
    },
  },

  page: {
    heading: 'Verlauf',
    lede: 'Was du mit deinem Konto gesehen hast, das zuletzt Markierte zuerst.',
    clear: 'Leeren',
    confirmDetail:
      'Das entfernt ihn aus deinem Konto auf der Instanz und nicht nur aus Visious, und es lässt sich nicht rückgängig machen.',
    clearing: 'Wird geleert…',
    loading: 'Dein Wiedergabeverlauf wird geladen…',
    listLabel: 'Wiedergabeverlauf',
    verified: 'Verifiziert',
    loadMore: (soFar) => `Mehr laden (bisher ${soFar})`,
    loadingMore: 'Wird geladen…',
    remove: (title) => `${title} aus deinem Verlauf entfernen`,
    removeTitle: 'Aus dem Verlauf entfernen',
    removing: 'Wird aus dem Verlauf entfernt',
  },

  write: {
    badVideoId:
      'Visious hat dieses Video nicht erkannt und wollte keine Anfrage senden, die deinen ganzen Verlauf hätte leeren können statt einen Eintrag zu entfernen. Es wurde nichts geändert.',
    badVideoIdTitle: 'Visious hat das nicht gesendet',
    refusedRemove: 'Die Instanz hat dieses Entfernen abgelehnt',
    refusedClear: 'Die Instanz hat es abgelehnt, den Verlauf zu leeren',
    refusedDetail:
      'Es wurde nichts geändert. Das ist ein Fehler hier und kein Problem mit deinem Konto, eine neue Anmeldung hilft also nicht.',
  },
};
